/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

type _Belegstatus = "ENTWURF" | "OFFEN" | "BEZAHLT" | "ANNULLIERT" | "UNEINBRINGLICH";

type Leer = "";

type Belegstatus = _Belegstatus | Leer;

export default Belegstatus;

export class BelegstatusWerte {
    public static readonly entwurf: Belegstatus = "ENTWURF";
    public static readonly offen: Belegstatus = "OFFEN";
    public static readonly bezahlt: Belegstatus = "BEZAHLT";
    public static readonly annulliert: Belegstatus = "ANNULLIERT";
    public static readonly uneinbringlich: Belegstatus = "UNEINBRINGLICH";
}